import api from '../../api/nodeBackApi';


export const createNotification = async (NotificationData) => {
  try {
    const response = await api.post(`/api/notifications/create`, NotificationData);
    return response.data;
  } catch (error) {
    console.error("Error al crear el Notification:", error.response?.data || error.message);
    throw error;
  }
};

export const getAllNotifications = async () => {
  try {
    const response = await api.get(`/api/notifications/getAll`);
    return response.data;
  } catch (error) {
    console.error("Error al obtener los Notifications:", error.response?.data || error.message);
    throw error;
  }
};

export const deactivateNotification = async (id) => {
  try {
    const response = await api.patch(`/api/notifications/${id}/deactivate`);
    return response.data;
  } catch (error) {
    console.error(`Error al desactivar el Notification con ID ${id}:`, error.response?.data || error.message);
    throw error;
  }
};

export const getActiveNotification = async () => {
  try {
    const response = await api.get(`/api/notifications/active`);
    return response.data;
  } catch (error) {
    console.error("Error al obtener el anuncio activo:", error.response?.data || error.message);
    throw error;
  }
};

export const deleteNotification = async (id) => {
  try {
    const response = await api.delete(`/api/notifications/${id}`);
    return response.data;
  } catch (error) {
    console.error(`Error al eliminar el Notification con ID ${id}:`, error.response?.data || error.message);
    throw error;
  }
};

export const activateNotification = async (id) => {
  try {
    // NOTA: Se asume que existe un endpoint para activar, que se encarga de desactivar cualquier otro anuncio activo.
    const response = await api.patch(`/api/notifications/${id}/activate`);
    return response.data;
  } catch (error) {
    console.error(`Error al activar el Notification con ID ${id}:`, error.response?.data || error.message);
    throw error;
  }
};
